import React from 'react';

export const Card = ({ children, className = "", noPadding = false }) => (
    <div className={`stat-card ${className} ${noPadding ? 'p-0' : ''}`}>
        {children}
    </div>
);

export const ChartCard = ({ children, title, className = "" }) => (
    <div className={`chart-container-card ${className}`}>
        <div className="chart-header">
            <h4 className="chart-title">{title}</h4>
        </div>
        {children}
    </div>
);

export const Avatar = ({ name, size = 40 }) => {
    const initials = name?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() || '?';
    const colors = ['#FF5526', '#FF5526', '#FF5526', '#10B981', '#F59E0B', '#EF4444'];
    const colorIndex = (name?.length || 0) % colors.length;

    return (
        <div
            style={{
                width: size,
                height: size,
                backgroundColor: colors[colorIndex],
                fontSize: size * 0.38,
                borderRadius: "50%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                lineHeight: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#FFFFFF",
                fontWeight: "800",
                flexShrink: 0,
                textShadow: "0 1px 2px rgba(0,0,0,0.1)"
            }}
        >
            {initials}
        </div>
    );
};

export const CustomProgressBar = ({ value, color = "#FF5526" }) => (
    <div className="custom-progress-bg">
        <div
            className="custom-progress-fill"
            style={{ width: `${value}%`, backgroundColor: color }}
        />
    </div>
);

export const formatRevenue = (value) => {
    if (value === 0) return "AED 0.0M";
    if (value >= 1000000000) {
        return `AED ${(value / 1000000000).toFixed(1)}B`;
    }
    return `AED ${(value / 1000000).toFixed(1)}M`;
};
